import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'
import NProgress from 'nprogress'
import { createRouter, createWebHistory } from 'vue-router'

function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

function getRoleFromStorages() {
  const keys = ['token', 'xToken', 'x-token', 'auth.token', 'jwt', 'access_token']
  for (const k of keys) {
    const raw =
      localStorage.getItem(k) ||
      sessionStorage.getItem(k) ||
      JSON.parse(localStorage.getItem('auth') || 'null')?.token ||
      JSON.parse(sessionStorage.getItem('auth') || 'null')?.token ||
      null
    const token = typeof raw === 'string' ? raw : null
    if (!token) continue
    const payload = decodeJwtPayload(token)
    if (payload?.role) return payload.role
  }
  return null
}

function getEffectiveRole() {

  const u =
    store.getters?.['user/user'] ||
    store.state?.user?.user ||
    store.state?.user?.data ||
    null
  if (u?.role) return u.role

  const roleFromToken = getRoleFromStorages()
  if (roleFromToken) return roleFromToken

  return null
}

const router = createRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  history: createWebHistory('/admin/'),
  routes: [
    {
      path: '/',
      name: 'Inicio',
      // VB:REPLACE-NEXT-LINE:ROUTER-REDIRECT
      redirect: '/inicio',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // VB:REPLACE-START:ROUTER-CONFIG
        {
          path: '/inicio',
          meta: { title: 'Inicio' },
          component: () => import('./views/main/mainIndex'),
        },
        {
          path: '/ui-kits/antd',
          meta: { title: 'Ant Design' },
          component: () => import('./views/ui-kits/antd'),
        },
        {
          path: '/widgets',
          meta: { title: 'Widgets' },
          component: () => import('./views/widgets'),
        },
        {
          path: '/widgets/general',
          meta: { title: 'General' },
          component: () => import('./views/widgets/general'),
        },
        {
          path: '/widgets/tables',
          meta: { title: 'Tables' },
          component: () => import('./views/widgets/tables'),
        },
        {
          path: '/widgets/charts',
          meta: { title: 'Charts' },
          component: () => import('./views/widgets/charts'),
        },
        {
          path: '/tables',
          meta: { title: 'Tables' },
          component: () => import('./views/tables'),
        },
        {
          path: '/tables/antd',
          meta: { title: 'Ant Design' },
          component: () => import('./views/tables/antd'),
        },
        {
          path: '/icons',
          meta: { title: 'Icons' },
          component: () => import('./views/icons'),
        },
        {
          path: '/icons/feather-icons',
          meta: { title: 'Feather Icons' },
          component: () => import('./views/icons/feather-icons'),
        },
        {
          path: '/icons/fontawesome',
          meta: { title: 'Fontawesome' },
          component: () => import('./views/icons/fontawesome'),
        },
        {
          path: '/icons/linearicons-free',
          meta: { title: 'Linearicons' },
          component: () => import('./views/icons/linearicons-free'),
        },
        {
          path: '/icons/icomoon-free',
          meta: { title: 'Icomoon Free' },
          component: () => import('./views/icons/icomoon-free'),
        },
        // VB:REPLACE-END:ROUTER-CONFIG
      ],
    },

    // ***************************************************************
    // ***************************************************************
    // Consignment Note Routes
    // CATALOGS
    {
      path: '/',
      name: 'catalogs',
      redirect: '/catalogos',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      beforeEnter: (to, from, next) => {
        const role = getEffectiveRole()

        if (!role) return next()

        if (role !== 'SUPER ADMIN') return next('/inicio')
        next()
      },
      children: [
        {
          path: '/catalogos/principal',
          meta: { title: 'Catalogos' },
          component: () => import('./views/catalogs/catalogMain'),
        },
        {
          path: '/catalogos/razon_social',
          meta: { title: 'Catálogo de Razón Social' },
          component: () => import('./views/catalogs/businessSetting/index'),
        },
        {
          path: '/catalogos/unidad_negocio',
          meta: { title: 'Catálogo Unidades de Negocio' },
          component: () => import('./views/catalogs/businessUnits/index'),
        },
        {
          path: '/catalogos/leyenda_carta',
          meta: { title: 'Catálogo Leyendas Carta Porte' },
          component: () => import('./views/catalogs/consignmentSettings/index'),
        },
        {
          path: '/catalogos/plantas',
          meta: { title: 'Catálogo de Plantas' },
          component: () => import('./views/catalogs/plants/index'),
        },
        {
          path: '/catalogos/usuarios',
          meta: { title: 'Catálogos de Usuarios' },
          component: () => import('./views/catalogs/users/index'),
        },
      ],
    },
    // CATALOGS
    // Consignment Note Routes
    // ***************************************************************
    // ***************************************************************

    // Historial
    // Consignment Note Routes
    // ***************************************************************
    // ***************************************************************
    {
      path: '/',
      name: 'consignment_note',
      redirect: '/carta_porte',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: '/carta_porte/principal',
          meta: { title: 'Historial' },
          component: () => import('./views/historial/historialMain'),
        },
        {
          path: '/carta_porte/pdf/:consignmentNoteId',
          meta: { title: 'PDF de Carta Porte' },
          component: () => import('./views/historial/components/fileConsignmentNote'),
        },
      ],
    },
    // Historial
    // Consignment Note Routes
    // ***************************************************************
    // ***************************************************************

    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          name: 'route404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          name: 'login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'route404' },
    },
  ],
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  setTimeout(() => {
    NProgress.done()
  }, 300)

  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.authorized) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
